module.exports = __webpack_public_path__ + "img/kiosk_logo.2dcbe20b.png";